// V2 flat capability model — 7 items in 3 domains (Knowing / Doing / Being)
// group 0 = Knowing (#7A3C9A)
// group 1 = Being   (#3DB09E)
// group 2 = Doing   (#3F95C8)

const capabilityCodes = [
    {
        code: 'K1',
        label: 'Principles & Values',
        fullStatement: 'Understand the principles and values of palliative care.',
        group: 0,
        index: 0
    },
    {
        code: 'K2',
        label: 'Unique Responses',
        fullStatement: 'Understand the unique responses of individuals, families and communities to life-limiting conditions, dying and death.',
        group: 0,
        index: 1
    },
    {
        code: 'D1',
        label: 'Communication',
        fullStatement: 'Use person and family-centred communication in the context of palliative care.',
        group: 2,
        index: 2
    },
    {
        code: 'D2',
        label: 'Inclusive Care',
        fullStatement: 'Provide inclusive and culturally safe care for people affected by life-limiting conditions.',
        group: 2,
        index: 3
    },
    {
        code: 'D3',
        label: 'Collaborative Care',
        fullStatement: 'Provide collaborative and person-centred care to optimise quality of life for people with life-limiting conditions.',
        group: 2,
        index: 4
    },
    {
        code: 'B1',
        label: 'Legislation & Frameworks',
        fullStatement: 'Respect ethical frameworks and legislation that support palliative care practice.',
        group: 1,
        index: 5
    },
    {
        code: 'B2',
        label: 'Ongoing Development',
        fullStatement: 'Participate in activities to develop self and services in the provision of palliative care.',
        group: 1,
        index: 6
    }
];

// V1 role-based capability codes — used for "Resources for" navigation mode
const capabilityCodesV1 = [
    {
        id: 6,
        name: "Aged Care Organisations",
        short: "ACO",
        order: "4",
        isWheelElement: true,
        items: [
            { description: "Advance Care Planning" },
            { description: "Recognise End of Life" },
            { description: "Assess Palliative Care Needs" },
            { description: "Provide Palliative Care" },
            { description: "Work Together" },
            { description: "Respond to Deterioration" },
            { description: "Manage Dying" },
            { description: "Bereavement" }
        ]
    },
    {
        id: 2,
        name: "Enrolled & Registered Nurses",
        short: "HP",
        order: "2",
        isWheelElement: false,
        items: [
            { description: "Person-centred communication in the context of an individual's responses to loss and grief, existential challenges, uncertainty and changing goals of care." },
            { description: "Appreciation of and demonstrated respect for the diverse human and clinical responses of each individual throughout their illness trajectory." },
            { description: "Understanding of principles for assessment and management of clinical and supportive care needs." },
            { description: "The capacity for reflection and self-evaluation of one's professional and personal experiences and their cumulative impact on one's self and others." }
        ]
    },
    {
        id: 3,
        name: "Care Workers",
        short: "CW",
        order: "5",
        isWheelElement: false,
        items: [
            { description: "Person-centred communication to build trust, show empathy and demonstrate support for individuals and carers living with a life-limiting illness." },
            { description: "Awareness of and demonstrated respect for the diverse human and clinical responses of each individual throughout their illness trajectory." },
            { description: "Understanding of clinical and supportive strategies that are within the scope of practice for individuals with a life-limiting illness." },
            { description: "The capacity to identify own emotional responses and ethical concerns and manage according to organisational policy and procedures." }
        ]
    },
    {
        id: 1,
        name: "Specialist Palliative Care Professionals",
        short: "S",
        order: "3",
        isWheelElement: false,
        items: [
            { description: "Advanced communication skills to establish, maintain and adapt effective therapeutic partnerships in the context of an individual's responses to loss and grief, existential challenges, uncertainty and changing goals of care." },
            { description: "The ability to negotiate mutually agreed goals of care within a therapeutic environment, and facilitate person-centred decision making to promote optimal outcomes." },
            { description: "Demonstrated skills in providing individualised and evidence based interventions to address the diverse human and clinical responses and preferences of each individual throughout their illness trajectory." },
            { description: "Advanced skills in holistic assessment of individuals with complex clinical and supportive care needs." },
            { description: "Expertise in use of assessment data to develop and implement a personalised and evidence based management plan and modify this plan according to changing circumstances, needs and preferences." },
            { description: "Understand the need for support for self and others and utilise appropriate support systems." },
            { description: "Contribute to quality palliative care outcomes through research, professional, policy and service development activities." },
            { description: "The ability to apply advanced understanding of contemporary legal, ethical and professional standards in palliative care service delivery and development." }
        ]
    },
    {
        id: 5,
        name: "Allied Health Professionals",
        short: "AHP",
        order: "1",
        isWheelElement: true,
        items: [
            { description: "Advance Care Planning" },
            { description: "Recognise End of Life" },
            { description: "Assess Palliative Care Needs" },
            { description: "Provide Palliative Care" },
            { description: "Work Together" },
            { description: "Respond to Deterioration" },
            { description: "Manage Dying" },
            { description: "Bereavement" }
        ]
    }
];

export {
    capabilityCodes,
    capabilityCodesV1
}
